import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RecoveryPasswordService } from './service/recovery-password.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NotificationsService } from '../../shared/components/notifications/service/notifications.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'features-recovery-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './recovery-password.component.html',
  styleUrl: './recovery-password.component.css'
})
export class RecoveryPasswordComponent {
  recoveryForm: FormGroup;
  isLoading = false;

  constructor(
    private recoverPasswordService: RecoveryPasswordService,
    private fb: FormBuilder,
    private notificationsService: NotificationsService
  ) {
    this.recoveryForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get email() {
    return this.recoveryForm.get('email');
  }

  onSubmit() {
    if (this.recoveryForm.invalid) {
      return;
    }

    this.isLoading = true;
    const email = this.email?.value;

    this.recoverPasswordService.recoverPassword(email).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.notificationsService.addNotification({
          message: 'Se ha enviado un enlace de recuperación a tu correo electrónico',
          type: 'success'
        });
        this.recoveryForm.reset();
      },
      error: (response)=>{
        this.isLoading = false;
        this.notificationsService.addNotification({
          message: response.error.message,
          type: 'error'
        });
      }
    });
  }
}
